import { render, staticRenderFns } from "./requisitionManage.vue?vue&type=template&id=4cd57183&scoped=true&"
import script from "./requisitionManage.vue?vue&type=script&lang=js&"
export * from "./requisitionManage.vue?vue&type=script&lang=js&"
import style0 from "./requisitionManage.vue?vue&type=style&index=0&id=4cd57183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd57183",
  null
  
)

export default component.exports